import { render, staticRenderFns } from "./el-progress-custom.vue?vue&type=template&id=2df25559&"
import script from "./el-progress-custom.vue?vue&type=script&lang=js&"
export * from "./el-progress-custom.vue?vue&type=script&lang=js&"
import style0 from "./el-progress-custom.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports